// if a vendor plugin doesnt want to load correctly add this line to the top of unminified version. this enables jquery within the plugin to work with webpack
// window.$ = window.jQuery = require('jquery');
import $ from 'jquery';
window.jQuery = $;
window.$ = $;

import 'intersection-observer';
import '../styles/main.scss';
import '../styles/vendor/slick.scss';
import './vendor/slick.js';
import {page} from './main.js';
import './mobileNav.js';
import './lazy-images.js';
import "./popup.js";


// WEBPACK FOOTER //
// ./scripts/app.js